import * as yup from 'yup';

export const pyroSiteSchema = yup.object().shape({
	size: yup.string().required('Lot size is required.'),
	attendants: yup.string().required('Participant number is required.'),
	dateAndTimes: yup.array().of(
		yup.object().shape({
			date: yup.string().required('Date is required.'),
			time: yup.string().required('Time is required.'),
		})
	),
	address: yup.string().required('Mailing address is required.'),
	city: yup.string().required('City is required.'),
	state: yup.string().required('State is required.'),
	zip: yup
		.string()
		.required('Zip Code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip code.'),
});
